//UI types
export interface IWarehouseBlock {
  width: number;
  height: number;
  top: number;
  left: number;
  labelWidth: number;
  labelTop: number;
  labelLeft: number;
  label: string;
  ref: any;
  refLabel: any;
}

export interface IWarehouseLink {
  label: string;
  link: string;
  img?: any;
  isLine?: boolean;
}

export interface IGetZoom {
  e: any;
  scale: number;
  dimensions: any;
  setDimensions: any;
  mapSVG: any;
}

//Action Types
interface WarehouseData {
  byZones: any[];
  noVolume: any[];
}

interface GetWarehouseDataAction {
  type: WarehouseTypes.GET_WAREHOUSE_DATA;
  payload: WarehouseData;
}

interface SetWarehouseLoadingAction {
  type: WarehouseTypes.SET_WAREHOUSE_LOADING;
}

interface GetWarehouseForecastAction {
  type: WarehouseTypes.GET_WAREHOUSE_FORECAST;
  payload: any[];
}

interface SetWarehouseForecastAction {
  type: WarehouseTypes.SET_WAREHOUSE_FORECAST;
  payload: number | null;
}

interface ClearWarehouseAction {
  type: WarehouseTypes.CLEAR_WAREHOUSE;
}

export enum WarehouseTypes {
  GET_WAREHOUSE_DATA = 'GET_WAREHOUSE_DATA',
  SET_WAREHOUSE_LOADING = 'SET_WAREHOUSE_LOADING',
  GET_WAREHOUSE_FORECAST = 'GET_WAREHOUSE_FORECAST',
  SET_WAREHOUSE_FORECAST = 'SET_WAREHOUSE_FORECAST',
  CLEAR_WAREHOUSE = 'CLEAR_WAREHOUSE',
}

export interface WarehouseState {
  byZones: any[];
  noVolume: any[];
  forecast: any[];
  forecastCoef: number | null;
  loading: boolean;
  loadingForecast: boolean;
}

export type WarehouseAction =
  | GetWarehouseDataAction
  | SetWarehouseLoadingAction
  | ClearWarehouseAction
  | GetWarehouseForecastAction
  | SetWarehouseForecastAction;
